import type { Translations } from './en';

export const es: Translations = {
  common: {
    myTrips: 'Mis Viajes',
    settings: 'Ajustes',
    signIn: 'Iniciar sesion',
    signOut: 'Cerrar sesion',
    signedIn: 'Conectado',
    account: 'Cuenta',
    email: 'Correo',
    password: 'Contrasena',
    confirmPassword: 'Confirmar contrasena',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    back: 'Volver',
    close: 'Cerrar',
    copy: 'Copiar',
    view: 'Ver',
    navigate: 'Navegar',
    copiedToClipboard: 'Copiado al portapapeles!',
    explore: 'Explorar',
    showMore: 'Ver mas',
    showLess: 'Ver menos',
    coachInstantSave: 'Toca para guardar este lugar en tu viaje',
    share: 'Compartir',
    updateAvailableTitle: 'Nueva versión disponible',
    updateAvailableBody: 'Actualiza para cargar la última versión de TripBoom. Tus cambios sin guardar pueden perderse.',
    refresh: 'Actualizar',
  },

  input: {
    interestedIn: 'Me interesa..',
    tagline: 'Tu ciudad, tu tiempo, a tu manera.',
    whereAreYou: 'Donde estas?',
    locationPlaceholder: 'Ciudad o barrio...',
    pleaseEnterLocation: 'Por favor ingresa una ubicacion',
    useMyCurrentLocation: 'Usar mi ubicacion actual',
    locationErrorRetry: 'Reintentar',
    locationErrorEnterManually: 'O introdúcela manualmente',
    howLong: 'Cuanto tiempo tienes?',
    howGettingAround: 'Como te desplazas?',
    imFeeling: 'Me siento...',
    pleaseSelectVibe: 'Por favor selecciona al menos un estilo',
    findMyAdventure: 'Encontrar mi aventura',
    placesFiltered: '{count} lugar{s} filtrado{s} - no abierto ahora',
    includeClosedPlaces: 'Incluir lugares cerrados',
  },

  share: {
    title: 'Compartir TripBoom',
    message: 'Esta app me organiz\u00F3 todo el d\u00EDa en 10 segundos \u2014 restaurantes, bares, planes. Pru\u00E9bala \uD83D\uDC47',
    copyLink: 'Copiar enlace',
    copied: '\u00A1Copiado!',
    shareOn: 'Compartir en',
    twitter: 'X',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    email: 'Correo',
    shareWithFriendTitle: 'Comparte con un amigo',
    earnSubtitle: 'Gana +2 búsquedas de Interés y +2 búsquedas AI High cuando se registren — o pídele que escanee el QR.',
    scanSubtitle: 'Escanea para abrir TripBoom en otro dispositivo',
    shareNow: 'Compartir ahora',
    shareViaQrAria: 'Toca para compartir TripBoom',
    shareMessage: 'Prueba TripBoom — tu concierge de viaje con IA. Usa mi enlace o escanea el QR: {url}',
  },

  time: {
    '1-2-hrs': '1-2 hrs',
    'half-day': 'Medio dia',
    'full-day': 'Dia completo',
    '2-3-days': '2-3 dias',
  },

  transport: {
    walking: 'Caminando',
    transit: 'Transporte',
    taxi: 'Taxi/Coche',
  },

  vibes: {
    hungry: 'Hambriento',
    adventurous: 'Aventurero',
    'must-sees': 'Imperdible',
    'feeling-lucky': 'Con suerte',
    popular: 'Popular',
    'hidden-gems': 'Joya oculta',
  },

  travel: {
    nearby: 'Cerca',
    rightHere: 'Aquí mismo',
    minWalk: '{n} min a pie',
    minTransit: '~{n} min en transporte público',
    minDrive: '~{n} min en coche',
    mins: '{n} min',
    hrMins: '{h} h {m} min',
    localSpot: 'Lugar local',
  },

  results: {
    placesFound: '{count} recomendaciones',
    findMorePlaces: 'Encontrar mas lugares',
    searchingWiderArea: 'Buscando en area mas amplia...',
    placesSelected: '{count} lugar{s} seleccionado{s}',
    saveTrip: 'Guardar viaje',
    viewTrip: 'Ver viaje',
    saving: 'Guardando...',
    saved: 'Guardado',
    iWannaGo: 'Quiero ir!',
    address: 'Direccion',
    hoursToday: 'Horario de hoy',
    visitWebsite: 'Visitar sitio web',
    copyHookLabel: 'Notas',
    copyTravelLabel: 'Traslado',
    copyMapsLabel: 'Google Maps',
    showingFiltered: 'Mostrando {filtered} de {total}',
    showingAll: 'Mostrando todo',
    offlineRankingBanner: 'IA no disponible — ordenado por valoración, distancia y horarios.',
  },

  loadingStages: {
    checkingLocation: 'Verificando ubicacion',
    checkingLocationNamed: 'Verificando {name}',
    discoveringPlaces: 'Descubriendo lugares',
    searchesComplete: '{completed}/{total} busquedas completadas',
    searchingCustomVibe: 'Buscando vibe personalizada...',
    mergingResults: 'Fusionando resultados...',
    deepSearching: 'Busqueda profunda de joyas ocultas',
    findingMore: 'Buscando mas opciones',
    sortingByRating: 'Ordenando por calificacion y distancia',
    aiMatchingVibes: 'IA coincidiendo vibes',
    aiAnalysing: 'IA analizando tus opciones',
    sendingToAi: 'Enviando a la IA...',
    processingResponse: 'Procesando respuesta...',
    filteringResults: 'Filtrando resultados...',
    analysedEliminated: '{analysed} analizados, {eliminated} eliminados',
  },

  poi: {
    moreLikeThis: 'Mas como esto',
    lessLikeThis: 'Menos como esto',
    moreLikeThisConfirm: 'Mas como esto',
    lessLikeThisConfirm: 'Menos como esto',
    cleared: 'Borrado',
    open: 'Abierto',
    closed: 'Cerrado',
    likelyOpen: 'Probablemente abierto',
    likelyClosed: 'Probablemente cerrado',
    easy: 'Facil',
    doable: 'Posible',
    far: 'Lejos',
    travelTimeEstimate: 'Estimacion basada en distancia — el tiempo real puede variar',
    travelTimeGoogle: 'Tiempo de viaje de Google Maps',
    foundOnTripBoom: 'Encontrado en TripBoom, tu concierge de viajes IA — tripboom.app',
  },

  cancel: {
    takingABreak: 'Un descanso?',
    pauseDescription: 'Pausa en lugar de cancelar — tu perfil de gustos y viajes guardados estan seguros.',
    proActiveUntil: 'Pro activo hasta el {date}',
    pauseMonths: 'Pausar {count} mes',
    pauseMonthsPlural: 'Pausar {count} meses',
    resumesOn: 'Se reanuda el {date}',
    resumeAnytime: 'Reanuda cuando quieras',
    pauseIndefinitely: 'Pausar indefinidamente',
    resumeWhenReady: 'Reanuda cuando estes listo',
    resumeFromSettings: 'Puedes reanudar en cualquier momento desde Ajustes. Tus datos siempre se conservan.',
    cancelInstead: 'Cancelar suscripcion',
    confirmTitle: '¿Cancelar Pro?',
    confirmBody: 'Mantienes Pro hasta el {date}; después tu cuenta vuelve al plan gratuito. Tus viajes guardados y tu perfil de gustos se conservan.',
    confirmBodyNoDate: 'Tu cuenta vuelve al plan gratuito. Tus viajes guardados y tu perfil de gustos se conservan.',
    keepPro: 'Mantener Pro',
    confirmCancel: 'Cancelar Pro',
  },

  installBanner: {
    addToHomeScreen: 'Agregar a pantalla de inicio',
    fileToDock: 'Agregar al Dock',
    bestExperience: 'mejor experiencia',
    install: 'Instalar',
    dismiss: 'Cerrar',
  },

  loading: {
    messages: [
      'Buscando cerca...',
      'Verificando horarios...',
      'Filtrando por distancia...',
      'Revisando calificaciones...',
      'Buscando joyas ocultas...',
      'Coincidiendo vibes...',
      'Ordenando resultados...',
      'Preguntando a los locales...',
      'Filtrando trampas turisticas...',
      'Encontrando lo bueno...',
      'Casi listo...',
    ],
  },

  settings: {
    title: 'Ajustes',
    aiMode: 'Soporte IA',
    aiModeDescription: 'Usar IA para priorizar, enriquecer y describir tus resultados',
    aiOffNotice: 'La IA esta desactivada. Los resultados se ordenaran por calificacion y distancia. Las descripciones usaran solo datos de Google.',
    aiLevelPrompt: 'Elige tu nivel de soporte IA:',
    aiLevels: {
      off: 'Desactivado',
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
    },
    aiLevelDescriptions: {
      low: 'Vibes rápidas, clasificación básica',
      medium: 'Tiempos de viaje, puntuación práctica',
      high: 'Búsqueda amplia, gustos personalizados',
    },
    showOnlyOpenPlaces: 'Mostrar solo lugares abiertos',
    filterClosedPlaces: 'Filtrar lugares cerrados en franjas horarias cortas',
    minimumStarRating: 'Calificacion minima',
    onlyShowRatingOrHigher: 'Solo mostrar lugares con esta calificacion o superior',
    any: 'Cualquiera',
    searchDistance: 'Distancia de busqueda',
    adjustSearchDistance: 'Ajusta la distancia de busqueda para cada combinacion de transporte y tiempo.',
    placeCategories: 'Categorias de lugares',
    categoriesUsedWhenAIFails: 'Las categorias se usan cuando la IA no puede clasificar.',
    settingsSessionOnly: 'Tus filtros solo duran esta sesión y se restablecen al actualizar. Inicia sesión para conservarlos.',
    settingsSavedLoggedIn: 'Los ajustes solo se guardan para usuarios conectados.',
    signInToSave: 'Inicia sesión para guardar tus viajes',
    installApp: 'Instalar aplicacion',
    installAppDescription: 'Agrega TripBoom a tu pantalla de inicio para acceso rapido',
    install: 'Instalar',
    tripGrouping: 'Agrupar viajes por',
    tripGroupingDescription: 'Elige como organizar tus viajes guardados',
    groupByDay: 'Dia',
    groupByLocation: 'Ubicacion',
    filters: 'Filtros',
    upgradeToPremium: 'Obtener Pro',
    unlimitedTripsDescription: 'Guardados, búsquedas y modo AI High ilimitados',
    upgrade: 'Actualizar',
    premiumMember: 'Miembro Pro',
    lifetimeAccess: 'Acceso de por vida a funciones y guardados ilimitados',
    yearlyAccess: 'Acceso anual a funciones y guardados ilimitados',
    appearance: 'Apariencia',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    themeSystem: 'Sistema',
    tasteProfile: 'Mapa de Gustos',
    interactions: 'interacciones',
    tripsPlanned: 'viajes planificados',
    topCategories: 'Categorias principales',
    topVibes: 'Vibras principales',
    tasteImproves: 'Tus recomendaciones mejoran con cada interaccion',
    topInterests: 'Principales intereses',
    travelStyle: 'Estilo de viaje',
    prefersNearby: 'Prefiere lo cercano',
    prefersExploring: 'Le encanta explorar lejos',
    mixedExplorer: 'Explorador mixto',
    prefersMixed: 'Explorador mixto',
    subscribe: 'Suscribirse',
    premiumAccess: 'Suscribirse a Pro',
    premiumSupporter: 'Miembro Pro',
    monthlyAccess: 'Acceso mensual a funciones y guardados ilimitados',
    getProCTA: 'Hazte Pro — Viajes y Creditos ilimitados',
    yourBenefits: 'Tus beneficios',
    yourCredits: 'Tus creditos',
    freeCredits: 'Tus creditos gratuitos',
    freeCreditsOnReg: 'Tus creditos gratuitos — al registrarte',
    dayGroups: 'Grupos de dias',
    locationGroups: 'Grupos de lugares',
    interestSearches: 'Busquedas de interes',
    highAiSearches: 'Búsquedas AI High',
    unlimited: 'Ilimitado',
    perMonth: '/mes',
    unlimitedInterestSearches: 'Busquedas de interes ilimitadas',
    unlimitedInterestSearchesFull: 'Busquedas "Me interesa..." ilimitadas',
    savedInterestsBenefit: 'Intereses guardados — personaliza cada busqueda',
    unlimitedGroups: 'Grupos de dias/lugares ilimitados',
    unlockArchived: 'Desbloquear viajes archivados',
    feedbackViaWebsite: 'Comentarios en el sitio web ↗',
    privacyAndData: 'Privacidad y datos ↗',
    contactSupport: "Contactar con soporte",
    deleteAccount: "Eliminar mi cuenta",
    deleteAccountTitle: "¿Eliminar tu cuenta?",
    deleteAccountBody: "Esto elimina para siempre tu cuenta, tus viajes guardados, los enlaces compartidos, tu perfil de gustos y tus créditos. No se puede deshacer.",
    deleteAccountCancel: "Conservar mi cuenta",
    deleteAccountConfirm: "Eliminar para siempre",
    deleteAccountDeleting: "Eliminando…",
    deleteAccountDone: "Tu cuenta y tus datos se han eliminado.",
    deleteAccountFailed: "Ahora mismo no podemos eliminar tu cuenta. Inténtalo de nuevo o escribe a support@tripboom.app.",
    deleteAccountActiveSub: "Tienes una suscripción de pago activa. Cancélala primero para que no se te cobre de nuevo y después elimina tu cuenta.",
    deleteAccountAdmin: "Las cuentas de administrador no se pueden eliminar desde la app.",
    pauseFrozenResume: 'Pago congelado — reanuda para reactivar Pro',
    pauseFrozenActiveUntil: 'Pago congelado — Pro activo hasta {date}',
    pauseFrozenExpires: 'Pago congelado — Pro expira, reanuda {date}',
    pauseFrozenActiveResumes: 'Pago congelado — Pro activo hasta {date}, reanuda {resumeDate}',
    yearlyActive: 'Anual — Activo',
    monthlyActive: 'Mensual — Activo',
    tripPassActive: 'Pase de Viaje — Activo',
    tripPassExpired: 'Pase de Viaje — expirado',
    tripPassDaysLeft: 'Pase de Viaje — {count} dia{s} restante{s}',
    yearlyRenews: 'Anual — renueva {date}',
    monthlyRenews: 'Mensual — renueva {date}',
    tipConcierge: 'Propina al Concierge',
    tipConciergeDescription: 'Pasaste un buen rato? Una propina nos ayuda a seguir adelante...',
    tipButton: 'Propina',
    tripPassAccess: 'Pase de Viaje — activo',
    tripPassLastDay: 'Trip Pass — ¡último día!',
    proPaused: 'Pro en pausa',
    proEnabled: 'Pro activado',
    proSubtitleFree: 'Búsquedas, guardados, créditos e IA ilimitados',
    upsellFromTripPass: 'Ahorra con una suscripción para créditos ilimitados en cada viaje',
    upsellFromMonthly: 'Cambia a anual y ahorra más del 50%',
  },

  auth: {
    welcomeBack: 'Bienvenido de nuevo',
    createAccount: 'Crear cuenta',
    signInDescription: 'Inicia sesión para guardar y acceder a tus viajes en todos tus dispositivos',
    iHaveAccount: 'Tengo una cuenta',
    imNewHere: 'Soy nuevo aqui',
    emailPlaceholder: 'tu@ejemplo.com',
    passwordPlaceholder: 'Ingresa tu contrasena',
    passwordMinChars: 'Al menos 6 caracteres',
    confirmPasswordPlaceholder: 'Ingresa la contrasena de nuevo',
    pleaseEnterEmail: 'Por favor ingresa tu correo',
    pleaseEnterPassword: 'Por favor ingresa tu contrasena',
    passwordTooShort: 'La contrasena debe tener al menos 6 caracteres',
    passwordsDoNotMatch: 'Las contrasenas no coinciden',
    signingIn: 'Iniciando sesion...',
    creatingAccount: 'Creando cuenta...',
    newHere: 'Nuevo aqui?',
    createAnAccount: 'Crear una cuenta',
    alreadyHaveAccount: 'Ya tienes una cuenta?',
    installWebApp: 'Instalar aplicacion',
    somethingWentWrong: 'Algo salio mal',
    apiCostNote: 'TripBoom usa APIs premium para encontrar tus lugares perfectos — es gratis para usar, pero considera pasarte a Pro para ayudarnos con nuestros costos.',
    emailSignInLink: 'Envíame un enlace de acceso',
    emailSignInLinkInstead: 'Mejor envíame un enlace de acceso',
    signInLinkTitle: 'Enlace de acceso',
    signInLinkDescription: 'Introduce tu correo y te enviaremos un enlace de acceso con un toque. Sin contraseña.',
    sendSignInLink: 'Enviar enlace de acceso',
    checkYourEmail: 'Revisa tu correo',
    signInLinkSentBody: 'Toca el enlace de acceso de tu correo para terminar. Funciona en cualquier navegador, incluido este. Revisa la carpeta de spam si no lo ves.',
    signInLinkOrCodeBody: "Toca el enlace del correo o escribe abajo el código que incluye. ¿Usas la app de TripBoom instalada? Usa el código: los enlaces se abren en tu navegador. Revisa la carpeta de spam si no lo ves.",
    signInCodeLabel: "Código de acceso",
    signInWithCode: "Entrar con el código",
    checkingCode: "Comprobando…",
    enterCodeFromEmail: "Escribe el código del correo.",
    codeInvalid: "Ese código no ha funcionado. Puede que haya caducado o ya se haya usado; pide uno nuevo.",
    forgotPassword: 'Olvidaste tu contrasena?',
    resetPassword: 'Restablecer contrasena',
    emailSent: 'Correo enviado',
    resetDescription: 'Ingresa tu correo y te enviaremos un enlace para restablecer tu contrasena.',
    sending: 'Enviando...',
    sendResetLink: 'Enviar enlace',
    resetLinkSent: 'Enlace de restablecimiento enviado',
    checkEmailForReset: 'Revisa tu correo para el enlace de restablecimiento. Revisa spam si no lo ves.',
    done: 'Listo',
    continueWithGoogle: 'Continuar con Google',
    googleSignInFailed: 'Error al iniciar sesion con Google',
    or: 'o',
    migrationNotice: 'Los usuarios beta registrados antes del {date} deberan crear una nueva cuenta — disculpa las molestias!',
  },

  savedTrips: {
    title: 'Viajes guardados',
    tripSaved: 'Viaje guardado!',
    noSavedTrips: 'No hay viajes guardados',
    selectPlacesPrompt: 'Selecciona lugares y guarda tu viaje para verlos aquí',
    backToAllTrips: 'Volver a todos los viajes',
    backToPlanning: 'Planificacion',
    newSearch: 'Nueva busqueda',
    mergeTrips: 'Fusionar viajes',
    selectTrips: 'Elegir viajes',
    merge: 'Fusionar',
    showAllTrips: 'Ver todos los viajes',
    places: 'lugares',
    deleteGroup: 'Eliminar grupo',
    deleteGroupConfirm: 'Eliminar todos los viajes de este grupo?',
    groupLimitReached: 'Has alcanzado el limite gratuito. Elimina un grupo o actualiza para guardar mas viajes.',
    trips: 'viajes',
    addToTrip: 'Agregar al viaje',
    newSuggestions: 'Nuevas sugerencias - selecciona para agregar',
  },

  itinerary: {
    title: 'Tu itinerario',
  },

  resetPassword: {
    verifying: 'Verificando tu enlace...',
    linkExpired: 'Enlace caducado o no válido',
    linkExpiredBody: 'Los enlaces para restablecer la contraseña caducan después de 1 hora. Solicita uno nuevo desde la pantalla de inicio de sesión.',
    backToTripBoom: 'Volver a TripBoom',
    updated: '¡Contraseña actualizada!',
    updatedBody: 'Ya has iniciado sesión con tu nueva contraseña.',
    goToTripBoom: 'Ir a TripBoom',
    setNew: 'Establece una nueva contraseña',
    setNewBody: 'Elige algo seguro — al menos 6 caracteres.',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    atLeast6: 'Al menos 6 caracteres',
    repeatPassword: 'Repite la contraseña',
    saving: 'Guardando...',
    submit: 'Guardar nueva contraseña',
    tooShort: 'La contraseña debe tener al menos 6 caracteres',
    mismatch: 'Las contraseñas no coinciden',
  },

  errors: {
    noOpenPlacesFound: 'No se encontraron lugares abiertos. {count} lugares estan actualmente cerrados.',
    noPlacesFound: 'No se encontraron lugares que coincidan con tus criterios. Intenta ajustar tu busqueda.',
    searchUnavailable: "Ahora mismo no podemos conectar con nuestro servicio de búsqueda. Tu búsqueda estaba bien; inténtalo de nuevo en un momento.",
    unableToRank: 'No se pudieron clasificar los lugares. Por favor intenta de nuevo.',
    genericError: 'Error: {message}. Por favor intenta de nuevo o ajusta tus criterios de busqueda.',
    locationNotFound: 'No se encontró ese lugar. Revisa la ortografía e inténtalo de nuevo.',
    signInForInterest: 'Inicia sesión para desbloquear más búsquedas de "Interesado en...". ¡Es gratis!',
    creditsExhaustedBody: 'Has usado tus créditos de búsqueda por intereses de este mes — ¡bien explorado! Consigue más compartiendo en la app, o hazte Pro para búsquedas ilimitadas.',
    dismiss: 'Cerrar',
    goPro: 'Hazte Pro',
  },

  payment: {
    upgradeFailed: "No se ha podido completar. No se ha cobrado nada; inténtalo de nuevo.",
    unlockUnlimited: 'Viajes y créditos ilimitados',
    upgradeDescription: 'Guarda tantos viajes como quieras, organizados a tu manera',
    limitReached: 'Limite de grupos alcanzado',
    dayLimitReached: 'Tienes {current} de {max} grupos de dias',
    locationLimitReached: 'Tienes {current} de {max} grupos de ubicaciones',
    bothLimitsReached: 'Tienes {maxDays} grupos de dias y {maxLocations} grupos de ubicaciones',
    whatYouGet: 'Lo que obtienes',
    unlimitedDayGroups: 'Grupos de dias ilimitados',
    unlimitedLocationGroups: 'Grupos de ubicaciones ilimitados',
    saveUnlimitedTrips: 'Guarda viajes ilimitados para siempre',
    aiHighMode: 'IA Alto — búsquedas adicionales y mejor coincidencia de gustos',
    monthly: 'Mensual',
    billedMonthly: 'Facturado mensualmente — cancela cuando quieras',
    yearly: 'Anual',
    billedAnnually: 'Facturado anualmente — cancela cuando quieras',
    perMonth: '/mes',
    perYear: '/año',
    bestValue: 'MEJOR VALOR',
    tripPass: 'Pase de Viaje',
    tripPassDescription: '7 dias de Pro — compra cuando viajes',
    oneOff: 'unico',
    whyWeCharge: 'Google nos cobra cada vez que usamos los datos basicos que son gratis en Maps. Nosotros anadimos IA, aprendizaje de gustos, priorizacion practica y mas. Solo podemos guardar datos de Google unos dias. Compartir esta app con otros, y tu apoyo financiero, nos mantiene en marcha. Y creemos que eso es genial.',
    upgradeNow: 'Actualizar ahora',
    processing: 'Procesando...',
    customTip: 'Propina al Conserje',
    customTipDescription: 'Una donación para ayudarnos a construir más',
    tipNow: 'Ingresa un monto arriba',
    thankYou: 'Muchas gracias!',
    securePayment: 'Pago seguro',
    upgradeSuccess: 'Bienvenido a TripBoom Pro!',
    premiumFeature: 'Pro',
    whyWeChargeTitle: '¿Por qué TripBoom tiene un nivel Pro?',
    billedAnnuallyNeutral: 'Ideal para viajeros frecuentes',
    billedMonthlyNeutral: 'Flexible — cancela cuando quieras',
    betaBannerTitle: 'Acceso Beta — todas las funciones Pro son gratis',
    betaBannerBody: 'No se te cobrará. Actívalo para desbloquear todo.',
    activateFreeBeta: 'Activar Beta gratis',
    betaActivate: 'Se activa al instante — sin pago',
  },
  categories: {
    restaurant: 'restaurante',
    cafe: 'cafeteria',
    bakery: 'panaderia',
    bar: 'bar',
    meal_takeaway: 'comida para llevar',
    meal_delivery: 'entrega de comida',
    fast_food_restaurant: 'comida rapida',
    coffee_shop: 'cafeteria',
    tourist_attraction: 'atraccion turistica',
    museum: 'museo',
    art_gallery: 'galeria de arte',
    church: 'iglesia',
    hindu_temple: 'templo hindu',
    mosque: 'mezquita',
    synagogue: 'sinagoga',
    park: 'parque',
    amusement_park: 'parque de atracciones',
    aquarium: 'acuario',
    zoo: 'zoologico',
    performing_arts_theater: 'teatro',
    cultural_center: 'centro cultural',
    national_park: 'parque nacional',
    campground: 'camping',
    hiking_area: 'zona de senderismo',
    marina: 'puerto deportivo',
    sports_club: 'club deportivo',
    sports_complex: 'complejo deportivo',
    stadium: 'estadio',
    ski_resort: 'estacion de esqui',
    athletic_field: 'campo deportivo',
    bowling_alley: 'bolera',
    book_store: 'libreria',
    night_club: 'club nocturno',
    liquor_store: 'tienda de licores',
    market: 'mercado',
    shopping_mall: 'centro comercial',
    casino: 'casino',
    spa: 'spa',
    movie_theater: 'cine',
  },

  referral: {
    friendShared: 'Un amigo te compartió TripBoom!',
    signUpNudge: 'Inicia sesión para desbloquear tus búsquedas gratuitas — y ganar créditos bonus para tu amigo.',
    signUpFree: 'Iniciar sesión gratis',
    maybeLater: 'Quizás después',
    totalsLine: '{count} amigos se unieron · +{interest} Interés · +{deep} Profunda',
    recentJoinersAria: 'Ver los últimos en unirse',
  },

  pin: {
    pinAria: 'Añadir este viaje a tu plan',
    unpinAria: 'Quitar este viaje de tu plan',
    pinPlanLabel: 'Anclar al plan',
    pinTripToPlanLabel: 'Anclar al plan',
    pinnedLabel: 'Anclado',
    yourPlanLabel: 'Tu plan',
    emptyHint: 'Abre cualquier viaje guardado y toca "Anclar al plan" para marcarlo como tu plan activo. Puedes tener hasta dos anclados a la vez.',
    emptyHintAria: 'Cómo anclar un viaje',
    mergePlan: 'Fusionar plan',
    mergePlanAria: 'Fusionar tus dos viajes anclados en un solo plan',
  },

  toasts: {
    welcome: 'Bienvenido a TripBoom! Empieza a explorar',
    firstShare: 'Tu primer viaje compartido!',
    firstSaveBonus: '¡Bienvenido! +5 búsquedas de interés y 3 búsquedas AI High desbloqueadas',
    saveFailed: 'No pudimos guardar ese viaje. Inténtalo de nuevo.',
    renamed: 'Viaje renombrado.',
    linkCopied: 'Enlace copiado.',
    deleteFailed: 'No se pudo eliminar. Inténtalo de nuevo.',
    renameFailed: 'No se pudo renombrar el viaje. Inténtalo de nuevo.',
    addPlacesFailed: 'No se pudieron añadir esos lugares. Inténtalo de nuevo.',
    loadFailed: 'No se pudieron cargar tus viajes. Mostramos lo último que teníamos.',
    cancelDone: 'Suscripción cancelada.',
    cancelFailed: 'No se pudo cancelar la suscripción. Inténtalo de nuevo.',
    pauseFailed: 'No se pudo pausar la suscripción. Inténtalo de nuevo.',
    resumeFailed: 'No se pudo reanudar la suscripción. Inténtalo de nuevo.',
    refundFailed: 'Sin resultados, y el reembolso del crédito falló. Contacta con soporte.',
    interestCreditRefunded: "Esa búsqueda no encontró nada, así que te devolvemos el crédito de interés.",
    subscriptionExpiredTitle: 'Tu suscripción ha terminado',
    subscriptionExpiredBody: 'Vuelve a suscribirte para desbloquear búsquedas, guardados e IA ilimitados.',
    subscriptionExpiredCTA: 'Ver planes',
    dismiss: 'Descartar',
    referralReward: '¡Tu amigo ganó +{interest} búsquedas de interés y {deep} búsquedas AI High!',
    noAiHighCredits: 'Sin créditos AI High — cambiado a Medio',
    aiHighLeft: 'AI High ({count} restantes)',
  },

  reevaluate: {
    headerButton: 'Ajustar',
    heroBannerTitle: 'Ajusta estos lugares según tu contexto',
    heroBannerSubtitle: 'Reordena según dónde estás, cómo te mueves y cuánto tiempo tienes',
    heroBannerCta: 'Ajusta estos lugares según tu contexto',
    title: 'Ajustar estos lugares',
    langLabel: 'Idioma:',
    subtitle: 'Reordena estos lugares según tu contexto: dónde estás, cómo te mueves y cuánto tiempo tienes.',
    locationLabel: 'Ubicación',
    locationOriginal: 'Original',
    locationCurrent: 'Actual',
    submitButton: 'Ajustar',
    reevaluating: 'Ajustando…',
    bannerTitle: 'Ajustado para ti',
    bannerSubtitle: 'Reordenado según tu contexto: {transport}, {time}.',
    offlineBannerTitle: 'IA no disponible',
    offlineBannerSubtitle: "Ordenado por valoración, distancia y horarios para: {transport}, {time}.",
    clear: 'Restablecer',
    saveCta: 'Guardar este viaje en mi cuenta',
    currentLocationLabel: 'Tu ubicación actual',
    noCoordinatesError: 'Este viaje no tiene datos de ubicación — prueba con Ubicación actual.',
    geoUnsupportedError: 'Tu navegador no admite servicios de ubicación.',
    geoPermissionError: 'Permiso de ubicación denegado. Elige Original.',
    geoFailedError: 'No pudimos obtener tu ubicación. Elige Original.',
    genericError: 'El ajuste falló. Inténtalo de nuevo.',
    toastSaved: '¡Viaje guardado! Fíjalo manualmente si quieres destacarlo.',
    toastSavedAndPinned: '¡Viaje guardado y fijado en tu plan!',
    savedTripButtonLabel: 'Ajustar',
    savedTripButtonTitle: 'Ajustar',
    savedTripButtonAria: 'Ajustar este viaje para un nuevo contexto',
    savedTripBannerTitle: 'Ajustado',
    savedTripSave: 'Guardar como nuevo viaje',
    savedTripSaveAria: 'Guardar este viaje ajustado como un nuevo viaje',
    savedTripDiscard: 'Descartar',
    savedTripDiscardAria: 'Descartar el ajuste y volver al orden original',
  },

  sharedTrip: {
    loadingTrip: 'Cargando viaje...',
    tripNotFound: 'Viaje no encontrado',
    tripNotFoundDesc: 'Este viaje puede haber sido eliminado o el enlace es incorrecto.',
    loadFailed: 'No pudimos cargar este viaje',
    loadFailedDesc: 'Algo salió mal al cargarlo. Es posible que el viaje siga disponible: inténtalo de nuevo.',
    retry: 'Reintentar',
    placesCount: '{count} lugares · Toca para explorar',
    ctaButton: 'Prueba TripBoom — es gratis',
    madeWith: 'Hecho con TripBoom, tu concierge de viajes con IA',
    aboutTagline: 'Tu concierge de viajes con IA. Dile lo que te apetece.',
    featureSearch: 'Búsqueda por ambiente',
    featureSearchDesc: 'Busca por estado de ánimo, no por palabras clave',
    featureAI: 'Clasificación IA',
    featureAIDesc: 'Resultados adaptados a tus gustos',
    featureSave: 'Guardar y Compartir',
    featureSaveDesc: 'Crea viajes y compártelos como este',
    featureFree: 'Gratis',
    featureFreeDesc: 'Sin necesidad de cuenta para empezar',
    linkFeatures: 'Funciones',
    linkPricing: 'Precios',
    linkInstall: 'Instalar',
  },
};
